import { type RouteObject } from 'react-router-dom';
// AdminV2 Pages - Import from feature
import {
  Agent as AgentPage,
  AnalyticsDocs as AnalyticsDocsPage,
  AppointmentDetail as AppointmentDetailPage,
  AppointmentsList as AppointmentsListPage,
  BillingDashboard as BillingDashboardPage,
  BillingDashboardDetail as BillingDashboardDetailPage,
  BundleDetail as BundleDetailPage,
  BundlesList as BundlesListPage,
  CapabilitiesList as CapabilitiesListPage,
  CapabilityDetail as CapabilityDetailPage,
  ContainerEntitiesList as ContainerEntitiesListPage,
  ContainerEntityDetail as ContainerEntityDetailPage,
  CortexPolicies as CortexPoliciesPage,
  CortexResources as CortexResourcesPage,
  DataMigrationsList as DataMigrationsListPage,
  EligibilityWorkqueue as EligibilityWorkqueuePage,
  EncounterDetail as EncounterDetailPage,
  EncountersList as EncountersListPage,
  EncounterTelemetrySessionsList as EncounterTelemetrySessionsListPage,
  EvalResultDetail as EvalResultDetailPage,
  EvalResultsList as EvalResultsListPage,
  FeatureExplorer as FeatureExplorerPage,
  FeedbackDashboard as FeedbackDashboardPage,
  FeedbackSessionsList as FeedbackSessionsListPage,
  ImportSessionDetail as ImportSessionDetailPage,
  IntakeHubAdmin as IntakeHubAdminPage,
  ModuleEdit as ModuleEditPage,
  ModuleGenerationSandbox as ModuleGenerationSandboxPage,
  MorningWorklist as MorningWorklistPage,
  NoteDetail as NoteDetailPage,
  NoteProcessingSessionDetail as NoteProcessingSessionDetailPage,
  NoteProcessingSessionsList as NoteProcessingSessionsListPage,
  NotesList as NotesListPage,
  NotFound as NotFoundPage,
  OrganizationDetail as OrganizationDetailPage,
  PayerSync as PayerSyncPage,
  ProspectDetail as ProspectDetailPage,
  ProspectsList as ProspectsListPage,
  ProviderDetail as ProviderDetailPage,
  RcmScoreboard as RcmScoreboardPage,
  SalesScoreboard as SalesScoreboardPage,
  Search as SearchPage,
  ShadowNotesList as ShadowNotesListPage,
  StreamingThreadDetail as StreamingThreadDetailPage,
  StreamingThreadsList as StreamingThreadsListPage,
  SystemNotifications as SystemNotificationsPage,
  TemplateConversionOutputViewer as TemplateConversionOutputViewerPage,
  TemplateDetail as TemplateDetailPage,
  TemplateModelConversion as TemplateModelConversionPage,
  TemplatesList as TemplatesListPage,
  TranscriptDetail as TranscriptDetailPage,
  TranscriptionsList as TranscriptionsListPage,
  VersionComparison as VersionComparisonPage,
} from '@features/admin-v2';
// Clinic Documents Admin Page
import { AdminClinicDocumentsPage } from '@features/clinic-documents';
// JotAudit Admin Pages
import {
  AdminJotAuditDashboardPage,
  EncounterAuditDetail,
  EncounterAuditsList,
  NoteAuditDetail,
  ProviderDetail,
  RuleAnalyticsPage,
} from '@features/jotaudit';
// Rules Admin Page
import { AdminRulesManagementPage as RulesManagementPage } from '@features/rules';

import { AdminLayout } from './layouts/AdminLayout';

export const adminV2Routes: RouteObject[] = [
  {
    path: '/admin-v2',
    element: <AdminLayout />,
    children: [
      {
        index: true,
        element: <SearchPage />,
      },
      {
        path: 'provider/:providerId',
        element: <ProviderDetailPage />,
      },
      {
        path: 'provider/:providerId/notes',
        element: <NotesListPage />,
      },
      {
        path: 'provider/:providerId/transcriptions',
        element: <TranscriptionsListPage />,
      },
      {
        path: 'provider/:providerId/encounters',
        element: <EncountersListPage />,
      },
      {
        path: 'provider/:providerId/appointments',
        element: <AppointmentsListPage />,
      },
      {
        path: 'provider/:providerId/note-processing-sessions',
        element: <NoteProcessingSessionsListPage />,
      },
      {
        path: 'provider/:providerId/streaming-threads',
        element: <StreamingThreadsListPage />,
      },
      {
        path: 'provider/:providerId/templates',
        element: <TemplatesListPage />,
      },
      {
        path: 'provider/:providerId/templates/:templateId/:templateVersion',
        element: <TemplateDetailPage />,
      },
      {
        path: 'provider/:providerId/templates/:templateId',
        element: <TemplateDetailPage />,
      },
      {
        path: 'provider/:providerId/templates/:templateId/compare',
        element: <VersionComparisonPage />,
      },
      {
        path: 'provider/:providerId/templates/:templateId/:templateVersion/module-edit',
        element: <ModuleEditPage />,
      },
      {
        path: 'templates/:templateId',
        element: <TemplateDetailPage />,
      },
      {
        path: 'templates/:templateId/compare',
        element: <VersionComparisonPage />,
      },
      {
        path: 'notes',
        element: <NotesListPage />,
      },
      {
        path: 'transcriptions',
        element: <TranscriptionsListPage />,
      },
      {
        path: 'encounters',
        element: <EncountersListPage />,
      },
      {
        path: 'appointments',
        element: <AppointmentsListPage />,
      },
      {
        path: 'transcript/:id',
        element: <TranscriptDetailPage />,
      },
      {
        path: 'encounter/:id',
        element: <EncounterDetailPage />,
      },
      {
        path: 'appointment/:id',
        element: <AppointmentDetailPage />,
      },
      {
        path: 'note/:noteId',
        element: <NoteDetailPage />,
      },
      {
        path: 'organization/:organizationId',
        element: <OrganizationDetailPage />,
      },
      {
        path: 'organization/:organizationId/data-migrations',
        element: <DataMigrationsListPage />,
      },
      {
        path: 'organization/:organizationId/data-migrations/session/:sessionId',
        element: <ImportSessionDetailPage />,
      },
      {
        path: 'note-processing-sessions',
        element: <NoteProcessingSessionsListPage />,
      },
      {
        path: 'note-processing-session/:npsId',
        element: <NoteProcessingSessionDetailPage />,
      },
      {
        path: 'jotaudit/:organizationId',
        element: <AdminJotAuditDashboardPage />,
      },
      {
        path: 'jotaudit/:organizationId/note/:noteId',
        element: <NoteAuditDetail />,
      },
      {
        path: 'jotaudit/:organizationId/rules/:ruleId/analytics',
        element: <RuleAnalyticsPage />,
      },
      {
        path: 'jotaudit/:organizationId/provider/:userId',
        element: <ProviderDetail />,
      },
      {
        path: 'jotaudit/:organizationId/encounters',
        element: <EncounterAuditsList />,
      },
      {
        path: 'jotaudit/:organizationId/encounter/:encounterId',
        element: <EncounterAuditDetail />,
      },
      {
        path: 'rules',
        element: <RulesManagementPage />,
      },
      {
        path: 'intake-hub',
        element: <IntakeHubAdminPage />,
      },
      {
        path: 'cortex/policies',
        element: <CortexPoliciesPage />,
      },
      {
        path: 'cortex/resources',
        element: <CortexResourcesPage />,
      },
      {
        path: 'feedback',
        element: <FeedbackDashboardPage />,
      },
      {
        path: 'feedback/sessions',
        element: <FeedbackSessionsListPage />,
      },
      {
        path: 'encounter-telemetry-sessions',
        element: <EncounterTelemetrySessionsListPage />,
      },
      {
        path: 'eval-results',
        element: <EvalResultsListPage />,
      },
      {
        path: 'eval-results/:resultId',
        element: <EvalResultDetailPage />,
      },
      {
        path: 'feature-explorer',
        element: <FeatureExplorerPage />,
      },
      {
        path: 'system-notifications',
        element: <SystemNotificationsPage />,
      },
      {
        path: 'module-generation-sandbox/:moduleId?',
        element: <ModuleGenerationSandboxPage />,
      },
      {
        path: 'capabilities',
        element: <CapabilitiesListPage />,
      },
      {
        path: 'capability/:capabilityId',
        element: <CapabilityDetailPage />,
      },
      {
        path: 'bundles',
        element: <BundlesListPage />,
      },
      {
        path: 'bundle/:bundleId',
        element: <BundleDetailPage />,
      },
      {
        path: 'streaming-threads',
        element: <StreamingThreadsListPage />,
      },
      {
        path: 'streaming-thread/:threadId',
        element: <StreamingThreadDetailPage />,
      },
      {
        path: 'template-conversion-output-viewer',
        element: <TemplateConversionOutputViewerPage />,
      },
      {
        path: 'template-model-conversion',
        element: <TemplateModelConversionPage />,
      },
      {
        path: 'eligibility-workqueue',
        element: <EligibilityWorkqueuePage />,
      },
      {
        path: 'morning-worklist',
        element: <MorningWorklistPage />,
      },
      {
        path: 'rcm-scoreboard',
        element: <RcmScoreboardPage />,
      },
      {
        path: 'sales-scoreboard',
        element: <SalesScoreboardPage />,
      },
      {
        path: 'billing-dashboard',
        element: <BillingDashboardPage />,
      },
      {
        path: 'billing-dashboard/:organizationId',
        element: <BillingDashboardDetailPage />,
      },
      {
        path: 'prospects',
        element: <ProspectsListPage />,
      },
      {
        path: 'prospect/:prospectSegmentId',
        element: <ProspectDetailPage />,
      },
      {
        path: 'payers/sync',
        element: <PayerSyncPage />,
      },
      {
        path: 'provider/:providerId/containers/:containerKey',
        element: <ContainerEntitiesListPage />,
      },
      {
        path: 'provider/:providerId/containers/:containerKey/:entityId',
        element: <ContainerEntityDetailPage />,
      },
      {
        path: 'shadow-notes',
        element: <ShadowNotesListPage />,
      },
      {
        path: 'agent',
        element: <AgentPage />,
      },
      {
        path: 'analytics-docs',
        element: <AnalyticsDocsPage />,
      },
      {
        path: 'clinic-documents/:organizationId',
        element: <AdminClinicDocumentsPage />,
      },
      {
        path: '*',
        element: <NotFoundPage />,
      },
    ],
  },
];
